import * as Yup from "yup";

export const addSingleAttendaceValidationSchema = Yup.object().shape({
  attendanceValue: Yup.number().required("Select attendance value"),
  attendanceDate: Yup.string().required("Select attendance date"),
  employeeCode: Yup.number()
    .typeError("Select employee")
    .required("Select employee"),
  inTime: Yup.string().required("Select attendance in time"),
  outTime: Yup.string().required("Select attendance out time"),
});

export const dayAttendanceValidationSchema = Yup.object().shape({
  attendanceDate: Yup.string().required("Attendance date is required"),
  attendance: Yup.array()
    .of(
      Yup.object().shape({
        // employeeCode: Yup.number()
        //   .required("Employee code is required")
        //   .integer("Employee code must be an integer"),
        attendanceValue: Yup.number().required("Attendance value is required"),
        inTime: Yup.string()
          .required("In time is required")
          .matches(
            /^([01]\d|2[0-3]):([0-5]\d)$/,
            "In time must be in HH:mm format",
          ),
        outTime: Yup.string()
          .required("Out time is required")
          .matches(
            /^([01]\d|2[0-3]):([0-5]\d)$/,
            "Out time must be in HH:mm format",
          ),
      }),
    )
    .min(1, "Attendance array must have at least one record")
    .required("Attendance is required"),
});

export const importAttendanceValidationSchema = Yup.object().shape({
  employeeCode: Yup.number().required(),
  attendanceYear: Yup.string().required(),
  attendanceMonth: Yup.string().required(),
  attendance: Yup.array().of(
    Yup.object().shape({
      date: Yup.string().required(),
      value: Yup.mixed().required(),
      inTime: Yup.mixed().required(),
      outTime: Yup.mixed().required(),
    }),
  ),
});

export const importAttendanceValidation = Yup.array().of(
  Yup.object().shape({
    employeeCode: Yup.mixed()
      .test("is-valid", "Employee Code must be a number", (value) =>
        /^\d+$/.test(value),
      )
      .required("Employee Code is required"),
    attendanceYear: Yup.string()
      .matches(/^\d{4}$/, "Attendance Year must be a 4-digit year")
      .required("Attendance Year is required"),
    attendanceMonth: Yup.string()
      .matches(/^([1-9]|1[0-2])$/, "Attendance Month must be between 1 and 12")
      .required("Attendance Month is required"),
    attendance: Yup.array()
      .of(
        Yup.object().shape({
          date: Yup.string()
            .matches(/^\d{4}-\d{2}-\d{2}$/, "Invalid date format")
            .required("Date is required"),
          value: Yup.mixed().required("Value is required"),
          inTime: Yup.mixed().nullable(),
          outTime: Yup.mixed().nullable(),
        }),
      )
      .required(),
  }),
);

export const bulkAttendanceValidationSchema = Yup.object().shape({
  companyCode: Yup.mixed().required("Company code is required"),
  fromDate: Yup.string().required("From date is required"),
  toDate: Yup.string().required("To date is required"),
  locationCode: Yup.mixed().required("Location code is required"),
  bulkAttendance: Yup.array()
    .of(
      Yup.object().shape({
        employeeCodes: Yup.array()
          .of(Yup.mixed().required("Employee code is required"))
          .min(1, "At least one employee code is required")
          .required("Employee codes are required"),
        attendanceValue: Yup.number().required("Attendance value is required"),
        inTime: Yup.string().required("In time is required"),
        outTime: Yup.string().required("Out time is required"),
        createUser: Yup.string().required("Create user is required"),
        createDate: Yup.string().required("Create date is required"),
        modifyUser: Yup.string().required("Modify user is required"),
        modifyDate: Yup.string().required("Modify date is required"),
        scheduleId: Yup.number(),
        projectCode: Yup.string(),
        shiftId: Yup.string(),
        remarks: Yup.string(),
        mode: Yup.string(),
        waitingTime: Yup.string(),
        isApproved: Yup.boolean(),
        oT1: Yup.number(),
        oT2: Yup.number(),
        extraCharge: Yup.number(),
        wtnhEdit: Yup.boolean(),
        supplierCompany: Yup.string(),
        service: Yup.string(),
        isReviewed: Yup.boolean(),
        reviewDate: Yup.string(),
        reviewBy: Yup.string(),
        approvedDate: Yup.string(),
        approvedBy: Yup.string(),
        haveSplit: Yup.boolean(),
        haveShift: Yup.boolean(),
      }),
    )
    .min(1, "Bulk attendance must have at least one record")
    .required("Bulk attendance is required"),
});

export const importTimelogValidationSchema = Yup.array().of(
  Yup.object().shape({
    slNo: Yup.number(), //.required("slNo is required"),
    companyCode: Yup.number().required("Company code is required"),
    locationCode: Yup.string().required("Location code is required"),
    employeeCode: Yup.number().required("Employee code is required"),
    attendanceValue: Yup.number().required("Attendance value is required"),
    attendanceDate: Yup.string().required("Attendance date is required"),
    inTime: Yup.string().required("In time is required"),
    outTime: Yup.string().required("Out time is required"),
    createUser: Yup.string().required("Create user is required"),
    createDate: Yup.string().required("Create date is required"),
    modifyUser: Yup.string().required("Modify user is required"),
    modifyDate: Yup.string().required("Modify date is required"),
    scheduleId: Yup.number(), //.required("Schedule ID is required"),
    projectCode: Yup.string(), //.required("Project code is required"),
    shiftId: Yup.string(), //.required("Shift ID is required"),
    remarks: Yup.string(), //.required("Remarks are required"),
    mode: Yup.string(), //.required("Mode is required"),
    waitingTime: Yup.string(), //.required("Waiting time is required"),
    isApproved: Yup.boolean(), //.required("Is approved is required"),
    oT1: Yup.number(), //.required("OT1 is required"),
    oT2: Yup.number(), ///.required("OT2 is required"),
    extraCharge: Yup.number(), //.required("Extra charge is required"),
    wtnhEdit: Yup.boolean(), //.required("WTNH Edit is required"),
    supplierCompany: Yup.string(), //.required("Supplier company is required"),
    service: Yup.string(), //.required("Service is required"),
    isReviewed: Yup.boolean(), //.required("Is reviewed is required"),
    reviewDate: Yup.string(), //.required("Review date is required"),
    reviewBy: Yup.string(), //.required("Review by is required"),
    approvedDate: Yup.string(), //.required("Approved date is required"),
    approvedBy: Yup.string(), //.required("Approved by is required"),
    haveShift: Yup.boolean(), // .required("Have shift is required"),
    wtrot: Yup.string(), //.required("WTROT is required"),
    normalHours: Yup.number(), //.required("Normal hours is required"),
  }),
);

export const weeklyOffValidationSchema = Yup.object().shape({
  attendanceValue: Yup.number().required().min(0),
  inTime: Yup.string().matches(
    /^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/,
    "Invalid time format",
  ),
  outTime: Yup.string().matches(
    /^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/,
    "Invalid time format",
  ),
  normalWorkingHours: Yup.string().required(),
  oT1: Yup.number().required(),
  oT2: Yup.number().required(),
  totalWorkingHours: Yup.number().required(),
  scheduleId: Yup.number().required(),
  shiftName: Yup.string(),
  projectCode: Yup.string(),
  projectName: Yup.string(),
  mode: Yup.string().oneOf(["MM", "AUTO", "MANUAL"]),
  waitingTime: Yup.string().matches(
    /^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/,
    "Invalid time format",
  ),
  isApproved: Yup.boolean(),
  remarks: Yup.string().required(),

  // extra fields
  dayworking: Yup.number().oneOf([0, 1]),
  extraCharge: Yup.number().min(0),
  late: Yup.string().matches(
    /^([0-1]\d|2[0-3]):([0-5]\d)$/,
    "Invalid HH:mm format",
  ),
  wtnhEdit: Yup.boolean(),
  supplierCompany: Yup.string(),
  service: Yup.string(),
  isReviewed: Yup.boolean(),
  reviewDate: Yup.string(),
  reviewBy: Yup.string(),
  approvedDate: Yup.string(),
  approvedBy: Yup.string(),
  haveSplit: Yup.boolean(),
  breakTime: Yup.number().min(0),
  salaryType: Yup.string().nullable(),
  wtrot: Yup.string().matches(
    /^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/,
    "Invalid time format",
  ),
  isPaidLeave: Yup.number().oneOf([0, 1]),
  hasOutTime: Yup.boolean(),
  defaultShift: Yup.number(),
  isHoliday: Yup.boolean(),
  isFullPaidLeave: Yup.boolean(),
  shiftId: Yup.string(),
  haveShift: Yup.boolean(),
  normalHours: Yup.number().min(0),
  // createUser: Yup.string().required(),
  // createDate: Yup.date().required(),
  // modifyUser: Yup.string().required(),
  // modifyDate: Yup.date().required(),
  isAlternateDayOff: Yup.boolean(),
});
